import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'rg_admin_token';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || null);
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  const fetchMe = useCallback(async (t) => {
    try {
      const { data } = await axios.get(`${API}/admin/me`, {
        headers: { Authorization: `Bearer ${t}` },
      });
      setAdmin(data);
      return true;
    } catch (e) {
      setAdmin(null);
      return false;
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (token) {
        const ok = await fetchMe(token);
        if (!ok) {
          localStorage.removeItem(TOKEN_KEY);
          setToken(null);
        }
      }
      setChecking(false);
    })();
  }, [token, fetchMe]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/admin/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setToken(data.token);
    await fetchMe(data.token);
    return data;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ token, admin, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { API };
